<template>
  <div class="app-page__container app-page__container--no-sidebar">
    <div v-if="isLoading" style="position: relative; min-height: 150px;">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as StandupActions from '@/store/actions/Standup.actions';

export default {
  name: 'SlackMeetingReminderView',

  props: {
    teamId: {
      type: String,
    },
  },

  data() {
    return {
      isLoading: true,
    };
  },

  mounted() {
    this.launchStartup(this.teamId);
  },

  computed: {
    ...mapState({
      teams: state => state.team.teams,
      standups: state => state.standup.standups,
      authUser: state => state.auth.authUser,
    }),
    newStandupPayload() {
      return {
        alreadyReportedUserIds: [],
        // Drawn by the first person to open the standup, then shared with every viewer.
        reportingOrderUserIds: [],
        hasReportingStarted: false,
        isStandupReportingComplete: false,
        currentReportingUserId: null,
        // Whoever launches the standup drives it with the keyboard / presentation clicker.
        launchedByUserId: this.authUser ? this.authUser.uid : null,
      };
    },
  },

  methods: {
    ...mapActions({
      fetchCurrentDayStandupByTeam: StandupActions.FETCH_CURRENT_DAY_STANDUP_BY_TEAM,
      createStandup: StandupActions.CREATE_STANDUP,
    }),
    async launchStartup(teamId) {
      this.isLoading = true;

      await this.fetchCurrentDayStandupByTeam({ teamId });

      const currentDayStandup = Object.values(this.standups).find(standup => standup.teamId === teamId);
      if (currentDayStandup) {
        this.$router.push(`/standup/${currentDayStandup.id}`);
      } else {
        const newStandupRef = await this.createStandup({ newStandup: { ...this.newStandupPayload, teamId } });

        this.$router.push(`/standup/${newStandupRef.id}`);
      }

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
